import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { Subject } from 'rxjs';

import { CanvasScreenshotService } from '../../../common/services/canvas-screenshot.service';
import { RouteHistoryService } from '../../../common/services/route-history.service';
import { OperationSignDocumentRequired } from '../../../shared/confirmation/core/models/operation-confirmation-required.model';
import { Wizard, WizardLoadingType } from '../../../shared/wizard-v2/wizard-core/wizard/wizard';
import { WizardComponent } from '../../../shared/wizard-v2/wizard-core/wizard/wizard.component';
import { MessageComponent } from '../../../ui/controls/message/message.component';
import { DeprecatedPopUpComponent } from '../../../ui/controls/pop-up/pop-up.component';
import { DocumentSignWizardService } from '../../statements-section/document-sign-wizard/document-sign-wizard.service';

import { InsuranceSportCreateWizardService } from './insurance-sport-create-wizard.service';
import { InsuranceSportCreateWizardFirstStepDataOfInsured } from './steps/insurance-sport-create-wizard-first-step-data-of-insured';
import { InsuranceSportCreateWizardFirstStepInsuranceParams } from './steps/insurance-sport-create-wizard-first-step-insurance-params';
import { InsuranceSportCreateWizardSecondStep } from './steps/insurance-sport-create-wizard-second-step';
import { InsuranceSportCreateWizardThirdStep } from './steps/insurance-sport-create-wizard-third-step';


@Component({
	selector: 'app-insurance-sport-create-wizard',
	templateUrl: './insurance-sport-create-wizard.component.html',
	styleUrls: ['./insurance-sport-create-wizard.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class InsuranceSportCreateWizardComponent implements WizardComponent, OnInit, OnDestroy {

	@ViewChild('checkRemoveInsuredPopupId', {static: true})
	public checkRemoveInsuredPopupId: DeprecatedPopUpComponent;

	@ViewChild('errorPopupId', {static: true})
	public errorPopupId: DeprecatedPopUpComponent;

	@ViewChild('messageComponent', {static: true})
	public messageComponent: MessageComponent;

	public operationSignDocumentRequired: OperationSignDocumentRequired;

	public wizard: Wizard;

	public ngUnsubscribe$$: Subject<void> = new Subject<void>();

	public isRemovedInsured: Subject<void> = new Subject<void>();

	public localDebounceTime: number = 200;

	constructor(
		public activatedRoute: ActivatedRoute,
		public insuranceSportCreateWizardService: InsuranceSportCreateWizardService,
		public canvasScreenshotService: CanvasScreenshotService,
		public domSanitazer: DomSanitizer,
		public routeHistoryService: RouteHistoryService,
		public changeDetectorRef: ChangeDetectorRef,
		public documentSignWizardService: DocumentSignWizardService,
	) {
		this.wizard = new Wizard('',
			{
				progressBarHidden: true,
				wizardLoadingType: WizardLoadingType.onWizard,
			},
		);
	}

	public ngOnInit(): void {
		// this.insuranceSportCreateWizardService.checkClientPersonalDataAgreement()
		// 	.pipe(
		// 		switchMap((result: boolean) => {

		// https://vm-jira.rs.ru/browse/IBFL-15062?focusedCommentId=932526
		// if (!result) {
		// 	this.wizard.addStep(new InsuranceAgreementFirstStep(this, this.wizard));
		// 	this.wizard.addStep(new InsuranceAgreementSecondStep(this, this.wizard));
		// 	this.wizard.addStep(new InsuranceAgreementThirdStep(this, this.wizard));
		// }

		this.wizard.addStep(new InsuranceSportCreateWizardFirstStepInsuranceParams(this, this.wizard));
		this.wizard.addStep(new InsuranceSportCreateWizardFirstStepDataOfInsured(this, this.wizard));
		this.wizard.addStep(new InsuranceSportCreateWizardSecondStep(this, this.wizard));
		this.wizard.addStep(new InsuranceSportCreateWizardThirdStep(this, this.wizard));

		this.wizard.start();

		// 		return of(null);
		// 	})
		// )
		// .subscribe();
	}

	public ngOnDestroy(): void {
		this.ngUnsubscribe$$.next();
		this.ngUnsubscribe$$.complete();
	}

	public onStepBackHandler: () => void = () => {
		this.routeHistoryService.backRoute();
	};

	public removedInsured(): void {
		this.isRemovedInsured.next();
		this.checkRemoveInsuredPopupId.close();
	}

	public closeCheckRemoveInsuredPopupPopup(): void {
		this.checkRemoveInsuredPopupId.close();
	}

	public closeErrorPopup(): void {
		this.wizard.back();

		this.errorPopupId.close();
	}
}
